import * as firebase from "firebase";
import { normalizeEmail, normalizePhone } from "./normalize";

// One email and one phone number per account: returns field errors when a new value is already on another
// customer, or null. `ownKey` is the customer the registration belongs to. A value that customer already
// has passes, so households that shared a number before this rule aren't locked out.

const maskEmail = (email) => {
  const [user, domain] = String(email || "").split("@");
  return domain ? `${user.slice(0, 2)}***@${domain}` : null;
};

const otherCustomers = async (field, value, ownKey) => {
  if (!value) return [];
  const snapshot = await firebase
    .database()
    .ref("customers")
    .orderByChild(field)
    .equalTo(value)
    .limitToFirst(3)
    .once("value");
  return Object.entries(snapshot.val() || {})
    .filter(([key]) => key !== ownKey)
    .map(([, customer]) => customer);
};

export const findContactConflicts = async ({ email, phone }, ownKey) => {
  const own = ownKey
    ? (await firebase.database().ref(`customers/${ownKey}`).once("value")).val() || {}
    : {};
  const newEmail = normalizeEmail(email) !== normalizeEmail(own.email) ? normalizeEmail(email) : null;
  const newPhone = normalizePhone(phone) !== normalizePhone(own.phone) ? normalizePhone(phone) : null;
  const [byEmail, byPhone] = await Promise.all([
    otherCustomers("email", newEmail, ownKey),
    otherCustomers("phone", newPhone, ownKey),
  ]);
  const errors = {};
  if (byEmail.length) {
    errors.email =
      "This email is already on another account. Use your own email address, or see staff at the counter.";
  }
  if (byPhone.length) {
    const hint = byPhone.length === 1 && maskEmail(byPhone[0].email);
    errors.phone = hint
      ? `This phone number is already on the account registered to ${hint}. Start over with that email, or see staff at the counter.`
      : "This phone number is already on another account. Use your own number, or see staff at the counter.";
  }
  return Object.keys(errors).length ? errors : null;
};



// WEBPACK FOOTER //
// ./src/common/contactConflicts.js